import React from 'react'
import {Link} from "react-router-dom";

function Menu({menuItem}) {
    return (
    <div>
            {
                menuItem.map((item, key) => {
                    return (
                    <Link className='link visited' key={key} to={`/product/${item.name}`}>
                    <div className="innerContainer" key={item.id}>
                        <div className="innerProductContainer">
                            <h2 className = "header">{item.name}</h2>
                            <h3 className = "header">$ {item.price}</h3>
                            </div>
                            <p className="p">{item.description.substring(0,150)}</p>
                            <hr></hr>
                    </div>
                    </Link>
                    );
                })
            }
        </div>
    )
}

export default Menu;
